// @ts-nocheck
// ====== Bulk edit clienti ======
// Toolbar nella vista Clienti per applicare in massa una delle seguenti
// operazioni sui clienti selezionati con checkbox:
//
//   1) accesso        -> imposta stato di un accesso (risorsa) per N clienti
//   2) perimetro-add  -> aggiunge un perimetro a N clienti
//   3) perimetro-del  -> rimuove un perimetro da N clienti
//   4) cpl/pm1/pm2    -> imposta CPL/PM1/PM2 a N clienti (vuoto = pulisci)
//
// Espone le funzioni su globalThis per il vecchio codice di clienti.js.

globalThis._bulkSelected = new Set();
const _bulkSelected = globalThis._bulkSelected;

function bulkClear() {
  _bulkSelected.clear();
  bulkUpdateToolbar();
}

function bulkToggle(name, on) {
  if (on) _bulkSelected.add(name);
  else _bulkSelected.delete(name);
  bulkUpdateToolbar();
}

function bulkUpdateToolbar() {
  const bar = document.getElementById('bulkToolbar');
  if (!bar) return;
  const n = _bulkSelected.size;
  bar.classList.toggle('active', n > 0);
  const countEl = bar.querySelector('.bulk-count');
  if (countEl) countEl.textContent = `${n} client${n === 1 ? 'e selezionato' : 'i selezionati'}`;

  // popola select risorse (solo prima volta)
  const selRes = document.getElementById('bulkRisorsa');
  if (selRes && !selRes._populated) {
    selRes.innerHTML =
      '<option value="">— Risorsa —</option>' +
      state.resources
        .map((r) => `<option value="${escapeHtml(r)}">${escapeHtml(r)}</option>`)
        .join('');
    selRes._populated = true;
  }
  // popola select perimetri
  const peri = typeof PERIMETRI !== 'undefined' && Array.isArray(PERIMETRI) ? PERIMETRI : [];
  ['bulkPerimetroAdd', 'bulkPerimetroDel'].forEach((id) => {
    const sel = document.getElementById(id);
    if (sel && !sel._populated) {
      sel.innerHTML =
        '<option value="">— Perimetro —</option>' +
        peri.map((p) => `<option value="${escapeHtml(p)}">${escapeHtml(p)}</option>`).join('');
      sel._populated = true;
    }
  });
}

function getOp() {
  return document.getElementById('bulkOperation')?.value || 'accesso';
}

function switchOpControls() {
  const op = getOp();
  document.querySelectorAll('#bulkToolbar .bulk-op-controls').forEach((el) => {
    el.classList.toggle('hidden', el.dataset.op !== op);
  });
}

async function bulkApply() {
  if (!isAdmin()) return;
  if (!_bulkSelected.size) {
    toast('Nessun cliente selezionato');
    return;
  }
  const op = getOp();
  if (op === 'accesso') return bulkApplyAccesso();
  if (op === 'perimetro-add') return bulkApplyPerimetro('add');
  if (op === 'perimetro-del') return bulkApplyPerimetro('del');
  if (op === 'cpl' || op === 'pm1' || op === 'pm2') return bulkApplyPerson(op);
}

// ===== Operazione: accesso risorsa =====
async function bulkApplyAccesso() {
  const resName = document.getElementById('bulkRisorsa').value;
  const stato = document.getElementById('bulkStato').value;
  if (!resName) {
    toast('Scegli una risorsa');
    return;
  }
  const ok = await confirmAction({
    level: 'warning',
    title: 'Modifica massiva accessi',
    message: `Stai per impostare l'accesso di "${resName}" a "${stato || '(rimosso)'}" su ${_bulkSelected.size} clienti.`,
    details: [
      ...Array.from(_bulkSelected).slice(0, 12),
      _bulkSelected.size > 12 ? `…e altri ${_bulkSelected.size - 12}` : null
    ].filter(Boolean),
    warning: 'Lo storico verrà aggiornato per ogni cliente coinvolto.',
    confirmText: 'Applica modifica'
  });
  if (!ok) return;
  const risorsaId = _resourceIdByName.get(resName);
  if (!risorsaId) {
    toast('Risorsa non trovata nel DB');
    return;
  }
  const items = [];
  for (const cliName of _bulkSelected) {
    const c = state.clients.find((x) => x.nome === cliName);
    if (c?._id) items.push({ cliente_id: c._id, risorsa_id: risorsaId, stato });
  }
  try {
    const { data, error } = await sb.rpc('bulk_update_accessi', { p_items: items });
    if (error) throw error;
    logAudit({
      action: 'update',
      entity: 'Cliente',
      target: `Bulk (${items.length})`,
      details: `Bulk: risorsa "${resName}" → "${stato || '(rimosso)'}" su ${items.length} clienti`
    });
    await loadStateFromSupabase();
    bulkClear();
    renderAll();
    toast(`Aggiornati ${data} accessi`);
  } catch (e) {
    console.error(e);
    toast('Errore bulk update: ' + (e.message || e));
  }
}

// ===== Operazione: perimetro add/del =====
async function bulkApplyPerimetro(mode) {
  const selId = mode === 'add' ? 'bulkPerimetroAdd' : 'bulkPerimetroDel';
  const peri = document.getElementById(selId).value;
  if (!peri) {
    toast('Scegli un perimetro');
    return;
  }
  const label = mode === 'add' ? 'Aggiungere' : 'Rimuovere';
  const ok = await confirmAction({
    level: 'warning',
    title: `${label} perimetro`,
    message: `Stai per ${mode === 'add' ? 'aggiungere' : 'rimuovere'} il perimetro "${peri}" su ${_bulkSelected.size} clienti.`,
    confirmText: 'Applica'
  });
  if (!ok) return;
  const targets = state.clients.filter((c) => _bulkSelected.has(c.nome));
  let changed = 0;
  for (const c of targets) {
    const cur = Array.isArray(c.perimetri) ? [...c.perimetri] : [];
    const has = cur.includes(peri);
    if (mode === 'add' && !has) cur.push(peri);
    else if (mode === 'del' && has) cur.splice(cur.indexOf(peri), 1);
    else continue;
    const { error } = await sb.from('clienti').update({ perimetri: cur }).eq('id', c._id);
    if (!error) changed++;
  }
  logAudit({
    action: 'update',
    entity: 'Cliente',
    target: `Bulk (${changed})`,
    details: `Bulk: ${mode === 'add' ? 'aggiunto' : 'rimosso'} perimetro "${peri}" su ${changed} clienti`
  });
  await loadStateFromSupabase();
  bulkClear();
  renderAll();
  toast(`Aggiornati ${changed} clienti`);
}

// ===== Operazione: CPL / PM1 / PM2 =====
async function bulkApplyPerson(field) {
  const inputId = field === 'cpl' ? 'bulkCpl' : field === 'pm1' ? 'bulkPm1' : 'bulkPm2';
  const value = (document.getElementById(inputId).value || '').trim();
  const dbField = field; // cpl, pm1, pm2 → colonna omonima
  const ok = await confirmAction({
    level: 'warning',
    title: `Imposta ${field.toUpperCase()}`,
    message: value
      ? `Imposta ${field.toUpperCase()} = "${value}" su ${_bulkSelected.size} clienti.`
      : `Rimuove ${field.toUpperCase()} (svuota campo) su ${_bulkSelected.size} clienti.`,
    confirmText: 'Applica'
  });
  if (!ok) return;
  const targets = state.clients.filter((c) => _bulkSelected.has(c.nome));
  let changed = 0;
  for (const c of targets) {
    const { error } = await sb
      .from('clienti')
      .update({ [dbField]: value })
      .eq('id', c._id);
    if (!error) changed++;
  }
  logAudit({
    action: 'update',
    entity: 'Cliente',
    target: `Bulk (${changed})`,
    details: `Bulk: ${field.toUpperCase()} ${value ? '→ "' + value + '"' : '(rimosso)'} su ${changed} clienti`
  });
  await loadStateFromSupabase();
  bulkClear();
  renderAll();
  toast(`Aggiornati ${changed} clienti`);
}

// La toolbar bulk vive nella vista "clienti" (lazy): wiring mount-safe e
// idempotente, rieseguito dopo l'iniezione del fragment.
function wireBulkEdit() {
  if (!document.getElementById('bulkApply')) return; // vista non ancora montata
  bindOnce(document.getElementById('bulkApply'), 'click', bulkApply);
  bindOnce(document.getElementById('bulkCancel'), 'click', () => {
    bulkClear();
    renderClienti();
  });
  bindOnce(document.getElementById('bulkOperation'), 'change', switchOpControls);
  switchOpControls(); // stato iniziale
}
document.addEventListener('DOMContentLoaded', wireBulkEdit);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') wireBulkEdit();
});

Object.assign(globalThis, { bulkToggle, bulkClear, bulkApply, bulkUpdateToolbar });
export {};
